import { usePermissions } from 'hooks';
import { Navigate } from 'react-router-dom';
import { NavigationRoutes } from 'utils/const';
import { PermissionEnum } from 'utils/enums';

interface PermissionRouteProps {
  entity: PermissionEnum;
  children: JSX.Element;
}

// Blocks direct URL access to a page when the user has no view right on it
const PermissionRoute = ({ entity, children }: PermissionRouteProps) => {
  const { canView, loading } = usePermissions({ entity });

  if (loading) return null;
  return canView ? (
    children
  ) : (
    <Navigate to={NavigationRoutes.dashboard} replace />
  );
};

export default PermissionRoute;
